<template>
  <li>
    <el-col :span="12">
      {{sku}}
    </el-col>
    <el-col :span="6">
      {{detail.unitprice | currency}} x {{detail.quantity}}
    </el-col>
    <el-col :span="6" class="text-right">
      {{price | currency}}
    </el-col>
  </li>
</template>

<script>
  import {currency} from '../../filters';

  export default {
    name: 'LogOnDetail',
    props: {
      /*
       * The props are everything that we get from LogOn on an order lookup.
       * The unused ones are left in here since this will be reused on the OCA
       * and RAA at some point.
       */
      detail: {
        required: true,
        type: Object,
        style: {
          required: true,
        },
        col: {
          required: true,
        },
        dm: {
          required: false,
        },
        size: {
          required: true,
        },
        quantity: {
          required: true,
        },
        unitprice: {
          required: true,
        },
        reference: {
          required: false,
        },
        priceoverridereasoncode: {
          required: false,
        },
      },
    },
    filters: {
      currency,
    },
    created() {
      this.sku = `${this.detail.style}_${this.detail.col}_${this.detail.size}`;
      this.price = this.detail.quantity * this.detail.unitprice;
    },
    data() {
      return {
        sku: '',
        price: 0,
      };
    },
  };
</script>
